export const fontZise1 = {
    fontSizeP: '14px',
    fontSizeH1: '28px',
    fontSizeH2: '21px',
    fontSizeH3: '17px',
    fontSizeH4: '14px',
    fontSizeH5: '13px',
    fontSizeH6: '12px',
  }
  export const fontZise2 = {
    fontSizeP: '15px;',
    fontSizeH1: '30px',
    fontSizeH2: '23px',
    fontSizeH3: '18px',
    fontSizeH4: '15px',
    fontSizeH5: '14px',
    fontSizeH6: '13px',
  }
  export const fontZise3 = {
    fontSizeP: '16px',      
    fontSizeH1: '32px',   
    fontSizeH2: '24px',     
    fontSizeH3: '19px',      
    fontSizeH4: '16px',      
    fontSizeH5: '14px',       
    fontSizeH6: '12px',   
  }
  export const fontZise4 = {
    fontSizeP: '20px',
    fontSizeH1: '40px',
    fontSizeH2: '30px',
    fontSizeH3: '24px',
    fontSizeH4: '20px',
    fontSizeH5: '18px',
    fontSizeH6: '14px',
  }
  export const fontZise5 = {
    fontSizeP: '24px',
    fontSizeH1: '48px',
    fontSizeH2: '36px',
    fontSizeH3: '30px',
    fontSizeH4: '24px',
    fontSizeH5: '22px',
    fontSizeH6: '16px',
  }

/* 
Font Sizes Matrix Values
     Base Value      miltiplier     Size 1      Size 2      Size 3 (Default)    Size 4    Size 5
 p      16px            1             14px       15px           16px             20px      24px
 h6     12px         * 3 / 5
 h5     14px         * 8/9
 h4     16px         * 1
 h3     19px         * 6/5
 h2     24px         * 3/2
 h1     32px         * 2

 */